import User from "@/utils/user";

const systemChildren = [
    {
        path: "/dev/system/cdn",
        permission: "manage_cdn",
    },
    {
        path: "/dev/system/cache",
        permission: "manage_cache",
    },
    {
        path: "/dev/system/sms",
        permission: "manage_sms",
    },
    {
        path: "/dev/system/app",
        group: 512,
    },
];

function hasSystemRoutePermission(item) {
    if (User.isSuperAdmin()) return true;
    if (item.group) return User.getGroup() >= item.group;
    if (!item.permission) return true;

    const permissions = User.getPermission().map((permission) => permission.action);
    return permissions.includes(item.permission);
}

function getSystemRedirect() {
    return systemChildren.find((item) => hasSystemRoutePermission(item))?.path || "/dev/index";
}

export default [
    {
        path: "/dev",
        name: "dev__root__",
        redirect: {
            name: "dev-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "dev",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "dev-index",
                component: () => import("@/views/dev/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/dev/conf",
        name: "dev-conf",
        meta: {
            title: "基础设置",
            icon: "atom",
            parent: "dev",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/conf/global",
        children: [
            {
                path: "global",
                name: "dev-conf-global",
                component: () => import("@/views/dev/conf/index"),
                meta: {
                    title: "全局配置",
                    icon: "global",
                    affix: false,
                    group: 512,
                },
            },
            {
                path: "static",
                name: "dev-conf-static",
                component: () => import("@/views/dev/conf/static"),
                meta: {
                    title: "静态配置",
                    icon: "config-file",
                    affix: false,
                    group: 512,
                },
            },
            // {
            //     path: "product",
            //     name: "dev-conf-product",
            //     component: () => import("@/views/dev/conf/product.vue"),
            //     meta: {
            //         title: "产品配置",
            //         icon: "product",
            //         affix: false,
            //     },
            // },
            // {
            //     path: "product-detail/:id(\\d+)?",
            //     name: "dev-conf-product-detail",
            //     hidden: true,
            //     component: () => import("@/views/dev/conf/product-detail.vue"),
            //     meta: {
            //         title: "产品配置详情",
            //         affix: false,
            //         activeMenu: "/dev/conf/product",
            //     },
            // },
        ],
    },
    {
        path: "/platform",
        alias: "/dev/platform",
        name: "dev-platform",
        meta: {
            title: "平台设置",
            icon: "platform",
            parent: "dev",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/platform/wxmp-menu",
        children: [
            {
                path: "wxmp-menu",
                name: "dev-platform-wx",
                component: () => import("@/views/dev/platform/wx-menus.vue"),
                meta: {
                    title: "微信菜单",
                    icon: "wxmp-menu",
                    affix: false,
                    permission: "manage_wxmp_menu",
                },
            },
            {
                path: "wxmp-conditional-menu",
                name: "dev-platform-wx-conditional-menu",
                component: () => import("@/views/dev/platform/wx-conditional-menus.vue"),
                meta: {
                    title: "个性菜单",
                    icon: "wxmp-conditional-menu",
                    affix: false,
                    permission: "manage_wxmp_menu",
                },
            },
            {
                path: "wxmp_material",
                name: "dev-platform-wxmp-material",
                component: () => import("@/views/dev/platform/wxmp-resource.vue"),
                meta: {
                    title: "微信素材",
                    icon: "wxmp-material",
                    affix: false,
                    permission: "manage_wxmp_material",
                },
            },
        ],
    },
    {
        path: "/dev/mstpl",
        name: "dev-mstpl",
        meta: {
            title: "消息模板",
            icon: "template",
            parent: "dev",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/mstpl/message",
        children: [
            {
                path: "message",
                name: "dev-mstpl-message",
                component: () => import("@/views/dev/mstpl/message-tpl.vue"),
                meta: {
                    title: "私信模板",
                    icon: "template-message",
                    permission: "manage_message_template",
                    affix: false,
                },
            },
            {
                path: "message-detail/:id(\\d+)?",
                name: "dev-mstpl-message-detail",
                hidden: true,
                component: () => import("@/views/dev/mstpl/message-detail.vue"),
                meta: {
                    title: "私信模板详情",
                    permission: "manage_message_template",
                    affix: false,
                    activeMenu: "/dev/mstpl/message",
                },
            },
            {
                path: "email",
                name: "dev-mstpl-email",
                component: () => import("@/views/dev/mstpl/email-tpl.vue"),
                meta: {
                    title: "邮件模板",
                    icon: "template-email",
                    permission: "manage_email_template",
                    affix: false,
                },
            },
            {
                path: "email-detail/:slug([\\w_-]+)?",
                name: "dev-mstpl-email-detail",
                hidden: true,
                component: () => import("@/views/dev/mstpl/email-detail.vue"),
                meta: {
                    title: "邮件模板详情",
                    permission: "manage_email_template",
                    affix: false,
                    activeMenu: "/dev/mstpl/email",
                },
            },
            {
                path: "phone",
                name: "dev-mstpl-phone",
                component: () => import("@/views/dev/mstpl/phone-tpl.vue"),
                meta: {
                    title: "短信模板",
                    icon: "template-phone",
                    permission: "manage_phone_template",
                    affix: false,
                },
            },
            {
                path: "wxmsg",
                name: "dev-mstpl-wxmsg",
                component: () => import("@/views/dev/mstpl/wxmsg-tpl.vue"),
                meta: {
                    title: "微信模板",
                    icon: "template-wxmsg",
                    permission: "manage_wxmsg_template",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/dev/devops",
        name: "dev-devops",
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/devops/deploy",
        meta: {
            title: "项目管理",
            icon: "pm",
            parent: "dev",
        },
        children: [
            // {
            //     path: "spider",
            //     name: "dev-pm-spider-legacy",
            //     hidden: true,
            //     redirect: "/pms/fsf/auto-task",
            // },
            // {
            //     path: "i18n",
            //     name: "dev-pm-i18n",
            //     component: () => import("@/views/dev/pm/i18n.vue"),
            //     meta: {
            //         title: "国际化",
            //         icon: "i18n",
            //     },
            // },
            // {
            //     path: "i18n-form/:id(\\d+)?",
            //     name: "dev-pm-i18n-form",
            //     hidden: true,
            //     component: () => import("@/views/dev/pm/i18n-form.vue"),
            //     meta: {
            //         title: "国际化",
            //         affix: false,
            //         activeMenu: "/dev/pm/i18n",
            //     },
            // },
            // {
            //     path: "i18n-detail/:id(\\d+)?",
            //     name: "dev-pm-i18n-detail",
            //     hidden: true,
            //     component: () => import("@/views/dev/pm/i18n-detail.vue"),
            //     meta: {
            //         title: "国际化详情",
            //         affix: false,
            //         activeMenu: "/dev/pm/i18n",
            //     },
            // },
        ],
    },
    {
        path: "/dev/stat",
        name: "dev-stat",
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/grafana",
        meta: {
            title: "统计分析",
            icon: "analyze",
            parent: "dev",
        },
        children: [
            {
                path: "/dev/grafana",
                name: "dev-grafana",
                component: () => import("@/views/dev/log/system/grafana.vue"),
                meta: {
                    title: "数据分析",
                    icon: "grafana",
                },
            },
            {
                path: "access-log",
                name: "dev-system-access-log",
                component: () => import("@/views/dev/log/system/access-log.vue"),
                meta: {
                    title: "访问统计",
                    icon: "clarity",
                },
            },
            {
                path: "frontend-log",
                name: "dev-system-frontend-log",
                component: () => import("@/views/dev/log/system/frontend-log.vue"),
                meta: {
                    title: "前端异常",
                    icon: "frontend-errors",
                },
            },
            {
                path: "backend-log",
                name: "dev-system-backend-log",
                component: () => import("@/views/dev/log/system/backend-log.vue"),
                meta: {
                    title: "后端异常",
                    icon: "backend-errors",
                },
            },
            {
                path: "wx",
                name: "dev-exception-wx",
                component: () => import("@/views/dev/exception/wx.vue"),
                meta: {
                    title: "平台异常",
                    icon: "wx-exception",
                },
            },
        ],
    },
    {
        path: "/dev/account",
        name: "dev-account",
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/account/list",
        meta: {
            title: "系统账号",
            icon: "admin",
            parent: "dev",
            group: 512,
        },
        children: [
            {
                path: "list",
                name: "account-list",
                component: () => import("@/views/dev/account/list.vue"),
                meta: {
                    title: "账号配置",
                    icon: "users",
                },
            },
            {
                path: "role",
                name: "account-role",
                component: () => import("@/views/dev/account/role.vue"),
                meta: {
                    title: "角色配置",
                    icon: "role",
                },
            },
            {
                path: "permission",
                name: "account-permission",
                component: () => import("@/views/dev/account/permission.vue"),
                meta: {
                    title: "权限配置",
                    icon: "permission",
                },
            },
            {
                path: "action-log",
                name: "dev-system-action-log",
                component: () => import("@/views/dev/log/system/action-log.vue"),
                meta: {
                    title: "管理日志",
                    icon: "log",
                },
            },
        ],
    },
    {
        path: "/dev/system",
        name: "dev-system",
        component: () => import("@/layouts/default.vue"),
        meta: {
            title: "系统管理",
            icon: "manage",
            parent: "dev",
        },
        redirect: getSystemRedirect,
        children: [
            {
                path: "cdn",
                name: "dev-system-cdn",
                component: () => import("@/views/dev/system/cdn.vue"),
                meta: {
                    title: "内容分发",
                    icon: "cdn",
                    affix: false,
                    permission: "manage_cdn",
                },
            },
            {
                path: "cache",
                name: "dev-system-cache",
                component: () => import("@/views/dev/system/cache.vue"),
                meta: {
                    title: "缓存管理",
                    icon: "redis",
                    affix: false,
                    permission: "manage_cache",
                },
            },
            {
                path: "sms",
                name: "dev-system-sms",
                component: () => import("@/views/dev/system/sms.vue"),
                meta: {
                    title: "短信管理",
                    icon: "sms",
                    affix: false,
                    permission: "manage_sms",
                },
            },
            {
                path: "dongle",
                name: "dev-system-dongle",
                component: () => import("@/views/dev/system/dongle.vue"),
                meta: {
                    title: "设备管理",
                    icon: "device",
                    group: 512,
                    affix: false,
                },
            },
            {
                path: "app",
                name: "dev-system-app",
                component: () => import("@/views/dev/system/app.vue"),
                meta: {
                    title: "应用管理",
                    icon: "project",
                    group: 512,
                    affix: false,
                },
            },
            {
                path: "server",
                name: "dev-system-server",
                component: () => import("@/views/dev/system/server.vue"),
                meta: {
                    title: "节点管理",
                    icon: "node",
                    group: 512,
                    affix: false,
                },
            },
        ],
    },
    // {
    //     path: "/dev/log",
    //     name: "dev-log",
    //     component: () => import("@/layouts/default.vue"),
    //     redirect: "/dev/log/action-log",
    //     meta: {
    //         title: "系统信息",
    //         icon: "system",
    //         parent: "dev",
    //     },
    //     children: [

    //     ],
    // },
];
